var exports = {
  "kL": "AvatarStack.module__container___N3AxaG",
  "my": "AvatarStack.module__avatar___N3AxaG",
  "KI": "AvatarStack.module__avatarButton___N3AxaG",
  "vn": "AvatarStack.module__avatarContent___N3AxaG",
  "ML": "AvatarStack.module__avatarContextMenuWrap___N3AxaG",
  "hm": "AvatarStack.module__withMask___N3AxaG",
  "i1": "AvatarStack.module__remainingCount___N3AxaG",
};

module.exports = exports;
